import { SeatDetail } from '@/src/types/itinerary'
import SeatRow from './seatRow'

const SeatRowWrapper = ({
    rowIndex,
    rowId,
    rowCharacteristics,
    seatDetails,
    totalColumns,
    selectedSeatOptions,
    handleAddSeat,
    handleRemoveSeat,
    getSeatColor,
    formatCurrency
}: {
    rowIndex: number
    rowId: string
    rowCharacteristics: string
    seatDetails: SeatDetail[]
    totalColumns: number
    selectedSeatOptions: Partial<SeatDetail>[]
    handleAddSeat: (seat: SeatDetail) => void
    handleRemoveSeat: (seat: SeatDetail) => void
    getSeatColor: (price: number) => string
    formatCurrency: (price: number) => string
}) => {
    return (
        <SeatRow
            rowIndex={rowIndex}
            rowId={rowId}
            rowCharacteristics={rowCharacteristics}
            seatDetails={seatDetails}
            totalColumns={totalColumns}
            selectedSeatOptions={selectedSeatOptions}
            handleAddSeat={handleAddSeat}
            handleRemoveSeat={handleRemoveSeat}
            getSeatColor={getSeatColor}
            formatCurrency={formatCurrency}
        />
    )
}

export default SeatRowWrapper
